import { Card, CardContent } from '@/components/ui/card';
import { formatCents } from '@/lib/utils';
import type { LucideIcon } from 'lucide-react';

interface FinancialCardProps {
  title: string;
  amount: number;
  icon: LucideIcon;
  variant?: 'default' | 'highlight';
}

export function FinancialCard({
  title,
  amount,
  icon: Icon,
  variant = 'default'
}: FinancialCardProps) {
  const isRcvDifference = variant === 'highlight';
  const isPositive = amount > 0;
  
  return (
    <Card 
      className={
        isRcvDifference && isPositive
          ? 'border-green-200 dark:border-green-800 bg-gradient-to-br from-green-50/50 to-emerald-50/50 dark:from-green-950/20 dark:to-emerald-950/20' 
          : isRcvDifference
          ? 'border-orange-200 dark:border-orange-800 bg-gradient-to-br from-orange-50/50 to-amber-50/50 dark:from-orange-950/20 dark:to-amber-950/20' 
          : ''
      }
    >
      <CardContent className="p-6">
        <div className="flex items-center justify-between">
          <div className="space-y-2">
            <p className="text-sm font-medium text-muted-foreground">{title}</p>
            <p 
              className={
                isRcvDifference && isPositive
                  ? 'text-2xl font-bold text-green-600 dark:text-green-400'
                  : 'text-2xl font-bold'
              }
            >
              {formatCents(amount)}
            </p>
          </div>
          <Icon className="h-8 w-8 text-muted-foreground" />
        </div>
      </CardContent>
    </Card>
  );
}
